import { jsx } from 'react/jsx-runtime';
import * as AlertDialogPrimitive from '@radix-ui/react-alert-dialog';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { contentStyle } from '../../dialog.vanilla.mjs';

const Content = forwardRef(
  ({ className, ...props }, ref) => {
    return /* @__PURE__ */ jsx(
      AlertDialogPrimitive.Content,
      {
        ref,
        className: classNames(className, contentStyle),
        ...props
      }
    );
  }
);

export { Content };
//# sourceMappingURL=Content.mjs.map
